import { Injectable } from '@angular/core';
import { NgxGalleryAnimation, NgxGalleryImageSize, NgxGalleryOrder } from '@kolkov/ngx-gallery';

@Injectable({
  providedIn: 'root',
})
/**
 * Provides Validation RegEx Patterns
 */
export class ConstantProviderService {

  //#region patterns
  public SEARCH_ITEMS = "Search items"
  public EMAIL_PATTERN = `^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,3})$`;
  public ZIP_CODE_PATTERN = '^[0-9]{5}$';
  public FAX_PATTERN = '^[0-9]{10}$';
  // public NAME_PATTERN = `^[A-Za-zÀ-ž®]{2,30}( [a-zA-ZÀ-ž®]+)?(-[a-zA-ZÀ-ž®]+)? McCafé®\s+Coffees$`;
  public STAFF_NAME_PATTERN = `^[A-Za-z]{2,}( [a-zA-Z]+)?(-[a-zA-Z]+)?$`;
  public SIGNUP_NAME_PATTERN = `^[a-zA-Z0-9 ]*[a-zA-Z]+[a-zA-Z0-9 ]*$`;
  
  public NAME_PATTERN = `^[A-Za-z]{2,60}([a-zA-Z]+)?(-[a-zA-Z]+)?$`;
  public CATEOGERY_NAME_PATTERN = `^[A-Za-zÀ-ž®]{2,30}( [a-zA-ZÀ-ž®]+)?(-[a-zA-ZÀ-ž®]+)? McCafé®\s+Coffees$`; 
  // public MENU_NAME_PATTERN = /^[a-zA-Z0-9]+([ \.\-'!@#$%^&*()_+=\[{\]};:'",<>\?\\/a-zA-Z0-9\s]+[a-zA-Z0-9])?$/;
  public MENU_NAME_PATTERN = /^[\p{L}\p{M}0-9!@#$%^&*()_+=\[{\]};:'"`’,<>\?\\/\s.-]+$/u;

  

  public DECIMAL_PATTERN = `^[0-9]{1,3}([.][0-9]{1,2})?$`;
  public PERCANTAGE_PATTERN = `^[0-9]{1,2}([.][0-9]{1,2})?$`;
  public TAX_PATTERN = '^[0-9]{1,2}([.][0-9]{1,3})?$';
  public MILES = '^[0-9]+(\.[0-9]+)?$';
  public NUMBER_PATTERN = '^[0-9]*$';
  // public URL_LINK_PATTERN = 'https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+[.][a-zA-Z]{2,3}|www[.][a-zA-Z0-9]+[.][a-zA-Z]{2,3}';
  public URL_LINK_PATTERN = 'https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+[.][a-zA-Z]{2,3}';
  // public FB_LINK_PATTERN = '(?:(?:http|https):\/\/)?(?:www.)?facebook.com/.+?';
  public FB_LINK_PATTERN = 'http(?:s)?:\/\/(?:www\.)?facebook.com/.+?';
  public TWITTER_LINK_PATTERN = 'http(?:s)?:\/\/(?:www\.)?twitter\.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+)';
  // public INSTAGRAM_LINK_PATTERN = '(?:(?:http|https):\/\/)?(?:www.)?instagram.com/.+?';
  public INSTAGRAM_LINK_PATTERN = 'http(?:s)?:\/\/(?:www\.)?instagram.com/.+?';
  public SUB_LINK_PATTERN = '^[a-z0-9-]*';
  // public APLHA_NUMERIC_PATTERN = '^(?![0-9]|[A-Z]*$)[A-Z0-9]+$';
  public APLHA_NUMERIC_PATTERN = '^[a-zA-Z0-9]+$';
  public PASSWORD_PATTERN = '^((?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{8,})$';
  public NAME_MAX_LENGTH = '50';
  
  //#endregion

  //#region Global Message

  public ARE_YOU_SURE = 'Are you sure you want to';
  public APPLY = 'Apply';
  public ADD = 'Add';
  public ADD_NEW = 'Add New';
  public ADD_TOPPING = 'Add Topping';
  public ADD_VARIANT = 'Add Variant';
  public ADD_OPTION = 'Add Option';
  public ACCESS_DENIED = 'Unauthorized User';
  
  public BACK = 'Back';
  public BACK_TO = 'Back To Orders';

  public CLOSE = 'Close';
  public CANCEL = 'Cancel';
  public CLEAR = 'Clear';
  public COPY_LINK = 'Copy Link';
  public CALL_ON = 'Call on +1';
  public CHAT = 'Chat';
  public CUSTOMER_ORDER_SEARCH = 'Search By Restaurant and Order No';
  public CONFIRM = 'Confirm';
  public CONFIRM_DELETE = 'Confirm and Delete';

  public DELETE = 'Delete';
  public DONE = 'Done';
  public DEMO = 'Demo';
  public DEACTIVATE_ITEM_STORE = 'Deactivate Item and Restaurant';

  public ERROR = 'Error';
  public EDIT = 'Edit';
  public EMAIL = 'Email Address';

  public FACEBOOK = 'Facebook';
  
  public FILTER_OPTION = 'Filter Options';

  public GO_TO_WEBSITE = 'Go to Website';

  public IMPORT = 'Import';
  public IMAGE_GALLERY = 'Image Gallery';

  public MAIL_TO = 'Mail to';
  public MORE = 'More';

  public NEXT = 'Next';
  public NOT_AVAILABLE = 'The resource you are trying to fetch is no longer available';
  public NOT_ALLOW_EMPTY = 'not allowed to be empty';

  public OOPS = 'Oops!!!';
  public ORDER_SEARCH = 'Search By Restaurant, Customer and Order No';
  public OK_GOT_IT = 'Okay, Got It'

  public PRINT = 'Print';
  public PAY_NOW = 'Pay Now';
  public PENDING_VERIFICATION = 'Pending Verification';
  public PAUSE_DELIVERY = 'Pause Orders';
  public PAUSE_NOW = 'Pause Now';
  public PERMISSON_CHANGED = 'Your account permissions have changed. Please login again.';

  public RESET = 'Reset';
  public REMOVE = 'Remove';
  public REFRESH = 'Refresh';
  public REMOVE_PREVIEW_IMAGE = 'Remove Preview Image';
  public REMOVE_SET_INACTIVE = 'Remove and Set Inactive';

  public SUCCESS = 'Success';
  public SELECT_RESTAURANT_FIRST = 'Select or add the restaurant first';
  public SELECT_PLAN_FIRST = 'Select a Plan First';
  public SEARCH_BY_ALL = 'Search By All';
  public SEARCH_BY_NAME = 'Search By Name';
  public SEARCH_BY_AMOUNT = 'Search By Amount';
  public SEARCH_BY_STAFF_DETAILS = 'Search By Employee, Email and Phone';
  public SEARCH_BY_ORDER_NO = 'Search By Order No';
  public SEARCH_BY_ITEM_NAME = 'Search By Item Name';
  public SEARCH_BY_CATEGORY = 'Search By Category';
  public SEARCH_BY_TITLE = 'Search By Title';
  public SEARCH_BY_TAG = 'Search By Cuisine'
  public SEND = 'Send';
  public SUBMIT = 'Submit';
  public SAVE = 'Save';
  public SAVE_UPDATE = 'Save & Update';
  public SAVE_CHANGES = 'Save Changes';
  public SESSION_EXPIRED_TITLE = 'Session expired';
  public SESSION_EXPIRED_MSG = 'Please sign in to keep continue your further activities';
  public SORRY = 'Sorry';
  
  public TWITTER = 'Twitter';

  public WHATSAPP = 'Whatsapp';

  public UPDATE = 'Update';
  public UPLOAD = 'Upload';

  public VIEW_DETAILS = 'View Details';
  public VIEW = 'View';
  public VIEW_EDIT = 'View/Edit';
  public VERIFY = 'Verify';
  public VERIFIED = 'Verified';
  public VIEW_RECEIPT = 'View Receipt';
  public VIEW_ALL_NOTIFICATION = 'View All Notifications';

  public YES_REMOVE = 'Yes, Remove';
  public YES= 'yes';
  public NO= 'no';

  //#endregion

  //#region Tooltip Message

  public CUSTOMER_INFO_TOOLTIP = 'Only verified customers are shown here.';
  public CARD_IMAGE_INFO = 'This image is shown in search results as a visual guide to what your menu offerings are, which may also include your restaurant’s branding on items such as cups, containers, etc.';
  
  public DBA_TOOLTIP = `Company's operating name rather than its legal name ( if applicable ).`;
  public LEGAL_NAME_TOOLTIP = 'Indicate how you write your legal business name. Such as "Best Burgers, LLC".';
  
  public EMAIL_TOOLTIP = 'Provide the email address which is unique to your restaurant.';
  public EIN_TOOLTIP = `If you use your social security number for TAX purposes, you can enter that instead.`;
  
  public KITCHEN_ORDER_INFO_TOOLTIP = 'Kitchen orders comes when manager or owner accept the order.';

  public MEDIA_GALLERY = 'Add your media and manage your uploads at single place.';
  public MENU_IMPORT_SIMPLE = `Simple file is a reference file which doesn't need any variants or toppings.`;
  public MENU_IMPORT_VARIABLE = `Variable File is a reference file with variants, toppings and custom items.`;
  public MENU_IMPORT_SELECT_FILE = 'Make sure menu item categories are created before importing items. If not created yet!!! Go to  Menu Editor.';
  public MENU_EDITOR_STOCK = 'Import common items directly using our stock item import option.';
  public MENU_GALLERY_INFO = 'These images represent specific food and dishes on your menu.';
  
  public NG_DEL_CONNECTION = 'This will enable Razor Delivery service and send orders to Razor Delivery Portal.';
  public NG_DEL_ACC_DETAILS = 'Use these credentials to login to Razor Delivery portal and use delivery service.';

  public LOGO_INFO = 'Logo will be displayed in a round format throughout the website as previewed here.';
  
  public PHONE_TOOLTIP = 'Please provide valid phone which is capable of receiving both calls and messages.';
  public PAYOUT_INFO_TOOLTIP = `Payouts are shown after restaurant's account set up with stripe.`;
  public PAYOUTS_INFO = `Payouts are shown after restaurant's account set up with stripe.`;

  public RESTAURANT_INFO_TOOLTIP = 'Fill the correct details about your restaurant.';
  public RESTAURANT_NAME_TOOLTIP = 'Please enter recognized restaurant name ( avoid using short names ).';
  public REFUND_INFO = 'Check order details before approved, Chat My Order is not responsible for any kind of fraud, issues etc.';
  public RESTAURANT_OPEN_CLOSE_TOOLTIP = 'Restaurant Open and Close Time Should Be Between 12:00 AM to 11:59 PM.';

  public STREET_TOOLTIP = 'Enter the exact pin location ( you can use Google maps for accurate address ).';
  public STORE_SETTING_TAX = `Input the amount of state or local sales tax you'd like added to your orders.`;
  public TAX_APPLICABLE = 'Sales Tax Rate will be applicable if this feild is empty and product is taxable.'
  public STORE_SETTING_SUB_DOMAIN = 'This is the link to your restaurant’s ChatMyOrder mini-site. Select a subdomain for your unique ChatMyOrder restaurant mini-site listing (such as www.joes.chatmyorder.com). Enter only the sub-domain such as “joes” in this example.';
  public STORE_SETTING_CUSTOM_MINI_SITE = 'As an alternative to using a mini-site subdomain, you can instead use a custom domain. Customers will be able to use either your subdomain or your custom domain to find your mini-site.';
  public STORE_SETTING_RADIUS = `Set the distance to which you're willing to accept orders. Consider how many minutes of travel it takes per mile, and factor in how long your typical order will be good for.`;
  public STORE_SETTING_CUTOFF = `Orders will stop being accepted X minutes before your restaurant closes. This ensures you don't get orders after you stop preparing food and close your kitchen.`;
  public STORE_SETTING_SPECIAL_FEE = 'Add additional fees such as a COVID-19 fees, etc.';
  public STORE_SETTING_MAIN_SUB_DOMAIN = `Your restaurant’s mini-site is auto-generated for your convenience using your restaurant’s information. It contains details such as your restaurant name, logo, bio, menus, address, etc. This allows you to share a beautified version of your general restaurant listing, as an alternative to building a custom website for your restaurant. You’ll soon have the ability to have more customization options, custom domain names, and more.`;
  public STORE_SETTING_FEE_DESCRIPTOR = 'This title/name will be displayed as a line-item on your order receipts and shown below the subtotal.';
  public STORE_SETTING_DELIVERY_CHARGE = 'Add a flat rate delivery fee if applicable - added to all orders. Otherwise, leave this box unchecked.';
  public STORE_SETTING_AMOUNT_INFO = 'If your restaurant has set up with CMO Rider amount should be considered from there and Amount should be in decimal.';
  public STORE_GALLERY_INFO = 'These are images of your brand, street level exterior images, interior of restaurant, and overall demonstrate the experience of a customer visiting your restaurant.';

  //#endregion

  //#region Validation Message
  
  public ADDITIONAL_PRICE = 'Additional Price is required';
  public ADDITIONAL_PRICE_PATTERN = 'Additional Price is not valid or it will accept up to only 2 decimal point places';
  public ATLEAST_ONE_OPTION = 'Atleast one option is required';
  public AMOUNT_REQUIRED = 'Amount is required';
  public AMOUNT_VALUE_REQUIRED = 'Discount Value is required';
  public AMOUNT_REQUIRED_PATTERN = 'Amount is not valid';
  public AMOUNT_VALUE_REQUIRED_PATTERN = 'Discount Value is not valid';
  public ADD_MAX_MIN_SELECTION = 'Add Minimum and Maximum selections';
  public ADD_ITEM_FIRST = 'Please add item first';
  public ADD_INSTRUCTION = 'Add Instrucation';
  public ADD_ADDRESS_DELIVERY = 'Add address for delivery';
  public ADDRESS_REQUIRED = 'Address is required';
  public AMOUNT_GREATER_5_CENT = 'Amount must be greater than or equal to 0.5';
  public ACCOUNT_TYPE = 'Account Type is required';
  public ACCOUNT_HOLDER_NAME = 'Account Holder Name is required';
  public ACCOUNT_NUMBER = 'Account Number is required';
  public ACCOUNT_NUMBER_LENGTH = 'Account Number length must be 12 digit';
  public ADD_COUPON_CODE = 'Please add coupon code';

  public BANK_ACCOUNT_DETAILS = 'Please Provide Valid Bank Account Details';

  public CATEGORY_REQUIRED = 'Category is required';
  public CITY_NAME = 'City is required';
  public CATEGORY_NAME = 'Menu Name is required';
  public COUNTRY_NAME = 'Country is required';
  public CONFIRM_PASSWORD = 'Confirm Password is required';
  public CONFIRM_PASSWORD_NOT_MATCH = 'Confirm Password do not match';
  public CURRENT_PASSWORD = 'Current Password is required';
  public CAPTCHA_MESSAGE = `Your computer or network may be sending automated queries. To protect our users we can't process your request right now.`;
  
  public DESCRIPTION_REQUIRED = 'Description is required';
  public REASON_REQUIRED = 'Refund Rejected Reason is required';
  public FEE_DESCRIPTION_REQUIRED = 'Fee Description is required';
  public DISCOUNT_AMOUNT_REQUIRED = 'Discount Amount is required';
  public DELIVERY_RADIUS_MILES_REQUIRED = 'Delivery Radius is required';
  public DELIVERY_RADIUS_MILES_REQUIRED_PATTERN = 'Delivery Radius is not valid';
  public DELIVERY_CHARGES_REQUIRED = 'Amount is required';
  public DELIVERY_CHARGES_REQUIRED_PATTERN = 'Amount is not valid';
  public DOB_REQUIRED = 'Date of Birth is required';
  public DISCOUNT_EXPIRED = 'This Discount is already expired';
  
  public EMAIL_REQUIRED = 'Email Address is required';
  public EMAIL_REQUIRED_PATTERN = 'Email Address is not valid';
  public END_DATE = 'End Date is required';
  public END_TIME = 'End Time is required'
  public ENTITY_TYPE_REQUIRED = 'Business Entity Type is required';
  public EIN_REQUIRED = 'EIN is required';
  public EIN_REQUIRED_LENGTH = 'EIN length must be 9 digit';
  public EMAIL_CHECK_ERROR = 'The email address is already taken';
  public EMAIL_EMPTY = 'Email Address is not allowed to be empty';

  public FULFILLMENT_REQUIRED = 'Order Fulfillment is required';
  public FIRST_NAME = 'First Name is required';
  public FIRST_NAME_PATTERN = 'First Name is not valid';
  public FIRST_DEPOSIT = 'First Deposit is required';
  public FB_LINK_NOT_VALID = 'Facebook link is not valid';
  public FUTURE_DATE = 'Not allowed future date or long past dates';
  public FEE_DESCRIPTOR_REQUIRED = 'Fee Title/Name is required';
  
  public GENDER_REQUIRED = 'Gender is required';

  public TYPE_ITEMS= 'Search items or sku';
  public ITEM_SKU = 'Item SKU is required';
  public ITEM_NAME = 'Item Name is required';
  public ITEM_NAME_PATTERN = 'Item Name is not valid';
  public ITEM_CATEGORY = 'Item Categories / Labels are required';
  public IMAGE_REQUIRED = 'Image is required';
  public IMAGE_DETAILS_UPDATED = 'Media gallery image details updated successfully';
  public IMAGE_TYPE_VALIDATION = 'File type should be png, jpg or jpeg';
  public INSTAGRAM_LINK_NOT_VALID = 'Instagram link is not valid';

  public KIOSK_NAME_REQUIRED = 'Kiosk name is required';

  public LAST_NAME = 'Last Name is required';
  public LAST_NAME_PATTERN = 'Last Name is not valid';
  public LOGIN_MESSAGE = 'Please sign in to keep continue your further activities';

  public MAXIMUM_SELECTION = 'Maximum Selection is required';
  public MINIMUM_SELECTION = 'Minimum Selection is required';
  public MINIMUM_SELECTION_LESS_THAN = 'Minimum Selection should be less than or equal to Maximum selection';
  public MEDIA_FILE_REQUIRED = 'Media File is required';
  public MENU_FILE_REQUIRED = 'Menu File is required';
  public MANAGER_REQUIRED = 'Manager is required';
  public MENU_ITEM_FIRST = 'Please select menu item first';
  public MAX_IMAGE_SELECTION = 'Maximum 8 images are select at once';
  public MESSAGE_REQUIRED = 'Message is required';
  public MESSAGE_EMPTY = 'Message is not allowed to be empty';

  public NAME = 'Name is required';
  public NAME_EMPTY = 'Name is not allowed to be empty';
  public NEW_PASSWORD = 'New Password is required';
  public NAME_STRING_PATTERN = 'must be 2-30 characters, Only 1 space or 1 hyphen allowed, Cannot start/end with a space or hyphen';
  public MENU_NAME_STRING_PATTERN= 'must be max 30 characters'

  public OPTION_NAME = 'Option Name is required';
  public ORDER_CUTOFF_TIME_REQUIRED = 'Last Orders Cutoff Time is required';
  public ORDER_CUTOFF_TIME_REQUIRED_PATTERN = 'Last Orders Cutoff Time is not valid';
  public ORDER_SAVED = 'Order Saved Successfully';
  
  public PHONE_REQUIRED = 'Phone Number is required';
  public PHONE_REQUIRED_LENGTH = 'Phone Number length must be 10 digit';
  public PASSWORD_REQUIRED = 'Password is required';
  public PASSWORD_INVALID = 'Password is not valid';
  public PASSWORD_REQUIRED_LENGTH = 'Password should contains from 6 to 15 characters';
  public PASSWORD_REQUIRED_PATTERN = 'Password must be at least 8 characters and contain at least 1 lowercase letter, 1 uppercase letter, 1 number';
  public PIN_REQUIRED = 'Passcode is required';
  public PIN_REQUIRED_LENGTH = 'Staff Passcode length must be exactly 6 digits';
  public PROFILE_REQUIRED = 'Profile updated successfully';
  public PASSWORD_CHANGED = 'Password changed successfully';
  public PROFILE_PIC_UPLOADED = 'Profile picture uploaded successfully';
  public PAYOUT_ORDERS_DETAILS = 'Payout orders are not available';
  public PRICE_REQUIRED = 'Price is required';
  public PRICE_NOT_VALID = 'Price is not valid or it will accept up to only 2 decimal point places'
  
  public REGULAR_PRICE = 'Regular Price is required';
  public REGULAR_PRICE_PATTERN = 'Regular Price is not valid or it will accept up to only 2 decimal point places';
  public CHANNEL_TYPE = 'Please Select Channel Type';
  public RESTAURANT_NAME = 'Restaurant Name is required';
  public RESTAURANT_LEGAL_NAME = 'Restaurant Legal Business Name is required';
  public RESTAURANT_EMAIL_REQUIRED = 'Restaurant Email Address is required';
  public RESTAURANT_EMAIL_REQUIRED_PATTERN = 'Restaurant Email Address is not valid';
  public RESTAURANT_PHONE_REQUIRED = 'Restaurant Phone is required';
  public RESTAURANT_PHONE_REQUIRED_LENGTH = 'Restaurant Phone length must be 10 digit';
  public ROUTING_NUMBER = 'Routing Number is required';
  public ROUTING_NUMBER_LENGTH = 'Routing Number length must be 9 digit';
  
  public SUBJECT_EMPTY = 'Subject is not allowed to be empty';
  public SALE_PRICE = 'Item Price is required';
  public SALE_PRICE_PATTERN = 'Item Price is not valid or it will accept up to only 2 decimal point places';
  public SALE_NOT_MORE_THAN = 'Sale Price is not more than Regular Price';
  public STREET_NAME = 'Address Line 1 is required';
  public STATE_NAME = 'State is required';
  public START_DATE = 'Start Date is required';
  public START_TIME = 'Start Time is required'
  public SUB_CATEGORY_REQUIRED = 'Category Name is required';
  public SELECT_VARIANT_ABOVE = 'Please select variant from above';
  public SELECT_ADDRESS =  'Select address for delivery';
  public SECOND_DEPOSIT = 'Second Deposit is required';
  public START_END_TIME_REQUIRED = 'Start Time and End Time both are required';
  public SUBJECT_REQUIRED = 'Subject is required';
  public SUB_DOMAIN_CHECK_ERROR = 'The sub domain is already taken';
  public STAFF_PASSCODE_LABLE = 'Staff Passcode (For accessing system when in Live Mode - 6 digits)';

  public TITLE_REQUIRED = 'Title is required';
  public TAG_REQUIRED = 'Cuisines & Food are required';
  public COST_FOR_TWO_REQUIRED = 'Restaurant Price Level is required';
  public TAX_PERCENT_REQUIRED = 'Sales Tax Rate is required';
  public TAX_PERCENT_REQUIRED_PATTERN = 'Sales Tax Rate is not valid';
  public TOPPING_OPTION_LENGTH = 'Topping Options length must be equal or greater than Minimum selections';
  public THROUGH_CASH = 'Make payment through cash';
  public THROUGH_CARD = 'Make payment through card';
  public TWITTER_LINK_NOT_VALID = 'Twitter link is not valid';
  
  public VARIANT_NAME = 'Variant Name is required';

  public WEBSITE_LINK_NOT_VALID = 'Website link is not valid';
  public WAIT_FOR_STORES = 'Please wait until restaurants are loaded';

  public ZIPCODE_NO = 'Zipcode is required';
  public ZIPCODE_NO_PATTERN = 'Zipcode is not valid';

  //#endregion

  //#region Auth Message

  public ACTIVE_WO_TIMEOUT = 'It keeping your session active without a timeout.';

  public BACK_SIGN_IN = 'Back to Sign In';

  public CHANGE_IT_HERE = 'Change it here';

  public EMAIL_EXISTS = 'Email already exists';

  public FORGOT_PASSWORD_LINK_RESEND_SUCCESS = 'Forgot Password reset link send successfully';
  public FORGOT_PASSWORD_LINK_RESEND_FAILED = 'Forgot Password reset link send failed';
  public FORGOT_PASSWORD = 'Forgot Password';

  public MOBILE_SUCCESS = 'Phone Number updated successfully';

  public OTP_DIGIT_MISSING = 'OTP digit is missing';
  public OTP_VERIFIED = 'OTP verified successfully';

  public RESET_PASSWORD = 'Password reset successfully';
  public RESEND_LINK = 'Resend Link';
  public RESEND = 'Re-send';
  public RESEND_OTP = ' OTP Re-send via text successfully';
  public RESEND_OTP_BY_CALL = ' OTP Re-send via call successfully';

  public SIGN_IN = 'Sign In';
  public SIGN_IN_SUCCESS = 'Sign In successful';
  public SIGN_UP = 'Sign Up';
  public SIGN_UP_FAILED = 'Account created failed';
  public SIGN_UP_SUCCESS = 'Account created successfully';
  
  public VERIFICATION_LINK_SENT = 'Verification link sent successfully';

  //#endregion

  //#region Header

  public COLLECT_PAYMENT = 'Collect Payment';
  public COLLECT = 'Collect';

  public NOTIFICATIONS = 'Notifications';

  public QUICK_ACTIONS = 'Quick Actions'

  //#endregion

  //#region POS Message

  public ADD_TO_POS = 'Add to POS';
  public UPDATE_TO_POS = 'Update to POS';
  public AT_LEAST_QTY = 'At least 1 quantity is required';

  public CLEAR_ALL_TEMP_ORDER = 'All temporary order cleared successfully';
  public CANCEL_PAUSE_DELIVERY = 'Pause delivery canceled successfully';
  public CHAT_ORDER = 'Chat Order';
  public CLEAR_THE_ORDER = 'Clear the order';
  public CHAT_MESSAGE_DELETED = 'Message deleted successfully';
  public CUSTOMER_CHATS = 'Customer Chats';

  public DECREASE_QTY = 'Decrease Quantity';
  public DISCOUNT_APPLIED = 'Discount applied successfully';
  public DELIVERY_PAUSE_TIME = 'Delivery pause time is required';

  public ESTABLISHED_CONNECTION = 'Please establish connection with the device';

  public INCREASE_QTY = 'Increase Quantity';

  public LOAD_ORDER_TO_POS = 'Load Order To POS';

  public STAY_PAUSE = 'No, Stay Paused.';

  public ORDER_PLACED = 'Order placed successfully';
  public OUT_OF_STOCK = 'Unavailable';

  public SAVE_TEMP_ORDER = 'Save Temp. Order';
  public SELECT_CUSTOMER_FIRST = 'Please select customer first';
  public SPECIAL_INSTRUCTION_SAVED = 'Order Instructions saved successfully';
  public SPECIAL_INSTRUCTION_REMOVED = 'Order Instructions removed successfully';
  public SPECIAL_INSTRUCTION_REQUIRED = 'Order Instructions are required';

  public VIRTUAL_TERMINAL = 'Virtual Terminals';
  
  public WALK_IN = 'Walk-In';

  public YES_UNPAUSE = 'Yes, Unpause.';

  //#endregion

  //#region Stripe Terminal Message

  public AMOUNT_LESS_THAN_1000 = 'Amount should be less than or equal to 1000';

  public CONNECT = 'Connect';

  public DISCONNECT = 'Disconnect';
  public DISCOVER_READER = 'Discover Readers';
  public DISCOVER_READER_SUCCESS = 'Reader discovered successfully';
  public DISCONNECTED_DEVICE = 'Device disconnected successfully';

  public NO_READER = 'No Readers Available';

  //#endregion

  //#region Orders Message
  
  public DETAILS_VEHICLE_TYPE = 'Delivery Vehicle is required';
  public DETAILS_ORDER_APT = 'Order Avg. Preparation Time is required';
  public DETAILS_ALTERNATIVE_UPDATE = 'Alternative item updated successfully';
  public DETAILS_ITEM_REFUNDED = 'Single item refunded successfully';
  public DETAILS_ORDER_CANCELED = 'Order canceled successfully';
  public DETAILS_ADD_TO_ORDER = 'Item added to the order successfully';
  public DETAILS_ITEM_DELETE = 'Item deleted from the order successfully';

  public LIST_ORDER_CSV = 'There is no available data to generate a CSV';
  public LIST_EXPORT_CSV = 'Export CSV';
  public LIST_PRINT_RECEIPT = 'Print Receipt';
  public LIST_RESET_FILTER = 'All fields have been reset';
  
  public UPDATE_ORDER = 'Order details updated successfully';

  public NO_MORE_STATUSES = 'No more statuses are available';


  //#endregion

  //#region Kitchen Order Message

  public KITCHEN_ORDER_STATUS = 'Order status updated successfully';

  //#endregion

  //#region Manager Staff Message

  public ADD_MANAGER_ADDED = 'Manager added successfully';

  public EDIT_MANAGER_UPDATED = 'Manager updated successfully';

  public LIST_MANAGER_DELETED = 'Manager deleted successfully';
  public LIST_MANAGER_ADD = 'Add Manager';
  public LIST_MANAGER_EDIT = 'Edit Manager';
  public LIST_MANAGER_DELETE = 'Delete Manager';
  public LIST_MANAGER_SEARCH = 'Search By Name, Email Address and Phone';

  //#endregion

  //#region Staffs
  
  public ADD_STAFFS_ADDED = 'Staff added successfully';

  public EDIT_STAFFS_UPDATED = 'Staff updated successfully';

  public LIST_STAFFS_DELETED = 'Staff deleted successfully';
  public LIST_STAFFS_ADD = 'Add Staff';
  public LIST_STAFFS_EDIT = 'Edit Staff';
  public LIST_STAFFS_DELETE = 'Delete Staff';
  public LIST_STAFFS_ASSIGN = 'Assign Role';
  public LIST_STAFFS_ASSIGNS = 'Assign Role(s)';
  public LIST_STAFFS_ASSIGN_UPDATE = 'Update Role(s)';
  public LIST_STAFFS_REMOVE_TEAM_MEMBER = 'Remove Team Member';
  public LIST_STAFFS_SEARCH = 'Search By Name, Email Address and Phone';
  public LIST_STAFFS_ASSIGNED = 'Staff role assigned successfully';
  public LIST_STAFFS_REMOVED = 'Staff removed successfully';

  //#endregion

  //#region Kitchen Staff Message

  public ADD_STAFF_ADDED = 'Kitchen Staff added successfully';

  public EDIT_STAFF_UPDATED = 'Kitchen Staff updated successfully';

  public LIST_STAFF_DELETED = 'Kitchen Staff deleted successfully';
  public LIST_STAFF_ADD = 'Add Kitchen Staff';
  public LIST_STAFF_EDIT = 'Edit Kitchen Staff';
  public LIST_STAFF_DELETE = 'Delete Kitchen Staff';
  public LIST_STAFF_SEARCH = 'Search By Name, Email Address and Phone';

  //#endregion

  //#region Restaurant Message

  public ADD_RESTAURANT_ADDED = 'Restaurant added successfully';

  public COMMON_LINK_COPIED = 'Link copied successfully';
  public COMMON_RESTAURANT_ADD = 'Add Restaurant';
  public COMMON_RESTAURANT_EDIT = 'Edit Restaurant';
  public COMMON_RESTAURANT_SETTINGS = 'Settings';
  public COMMON_CHECK_EMAIL = 'This email address is unique';
  public COMMON_SELECT_FILE_FIRST = 'Please select a file first';
  public COMMON_FILL_EIN = 'Please fill EIN first';
  public COMMON_DOC_UPDATED = 'Document uploaded successfully';
  public COMMON_UPLOAD_DOC_FILE = 'Upload Document File';

  public DETAILS_MENU_IMAGE_REMOVED = 'Menu Image removed successfully';
  public DETAILS_RESTAURANT_IMAGE_REMOVED = 'Restaurant Image removed successfully';
  public DETAILS_MENU_IMAGE_UPLOADED = 'Restaurant Menu uploaded successfully';
  public DETAILS_RESTAURANT_IMAGE_UPLOADED = 'Restaurant Gallery uploaded successfully';
  public DETAILS_MANAGER_ASSIGNED = 'Manager assigned successfully';
  public DETAILS_LOGO_UPLOADED = 'Restaurant logo uploaded successfully';
  public DETAILS_CARD_IMAGE_UPLOADED = 'Restaurant card Image uploaded successfully';
  public DETAILS_LOGO_REMOVED = 'Restaurant logo removed successfully';
  public DETAILS_CARD_IMAGE_REMOVED = 'Restaurant card image removed successfully';
  public DETAILS_BUSINESS_HOURS_ADDED = 'Business Hours added successfully';
  public DETAILS_BUSINESS_HOURS_UPDATED = 'Business Hours updated successfully';
  public DETAILS_ASSIGN_MANAGER = 'Assign Manager';
  public DETAILS_ADD_LOGO = 'Add Logo';
  public DETAILS_ADD_SCREEN_SAVER = 'Add Screen Saver';
  public DETAILS_CHANGE = 'Change';
  public DETAILS_ADD_CARD_IMAGE = 'Add Card Image';
  public DETAILS_SETUP_PAYMENTS = 'Setup Payments';
  public DETAILS_ADD_RESTAURANT_GALLERY = 'Add Restaurant Gallery';
  public DETAILS_ADD_MENU_GALLERY = 'Add Menu Gallery';
  public DETAILS_ADD_IMAGES = 'Add Images';
  public DETAILS_BUSINESS_HOURS_ADD_EDIT = 'Add/Edit';
  public DETAILS_ACTIVATE_RESTAURANT = 'Please activate this restaurant from the list To see in the website';
  public DETAILS_UNDER_REVIEW = 'Restaurant details goes under review successfully';
  public DETAILS_MENU_GALLERY_UNDER_REVIEW = 'Menu gallery goes under review successfully';
  public DETAILS_STORE_GALLERY_UNDER_REVIEW = 'Store gallery goes under review successfully';
  public DETAILS_LOGO_UNDER_REVIEW = 'Restaurant logo goes under review successfully';
  public DETAILS_CARD_IMAGE_UNDER_REVIEW = 'Restaurant card image goes under review successfully';
  public DETAILS_APT_UPDATED = 'Restaurant Avg. Preparation Time per hours updated successfully'
  
  public EDIT_RESTAURANT_UPDATED = 'Restaurant updated successfully';

  public LIST_VERIFY_PHONE = `Restaurant's phone verified successfully`;
  public LIST_RESTAURANT_SEARCH = 'Search By Name, Email or Phone';
  public LIST_CLICK_TO_VERIFY = 'Click To Verify';
  public LIST_PRINT_QR_CODE = 'Print QR Code';
  public LIST_SHARE_QR_CODE = 'Share QR code';
  public LIST_DOWNLOAD_QR_CODE = 'Download QR Code';

  public TAGS_LABEL = 'Select your primary categories (up to 3) - Recommended';
  public TAGS_INFO = `When customers browse the website, restaurants are displayed with 3 sample categories displayed (A-Z).
                      By selecting your primary categories, it allows your customers to see what is most important to you.
                      Your customers can still see all of your categories on your restaurant's main page.`

  public STORE =  {
    SELECT_CHANNEL: {
      INFO: 'You can create restaurant for Cmo as well as Deliverect by selecting channel'
    },
    ADD_EDIT: {
      STORE_NAME_INFO: 'This name is shown publicly to all customers.',
      PRICE_LEVEL_INFO: 'This helps customers decide meals according to their budget.',
      FULFILLMENT_LABLE_1: 'One option must always be selected.',
      FULFILLMENT_LABLE_2: 'If you want to temporarily stop orders for your restaurant, set the status to Inactive.',
      DELIVERY_NGDEL_FULFILLMENT: 'You are currently subscribed to NextGen Delivery. This option cannot be disabled unless the service is canceled first.',
      DELIVERY_RIDER_FULFILLMENT: 'You are currently subscribed to Chat My Order Driver Network. This option cannot be disabled unless the service is canceled first.',
      PHONE_TEXT: 'Shown on your restaurant page.',
      EMAIL_TEXT: 'Hidden from customers. Used for administrative reasons only.',
      SOCIAL_MEDIA_TEXT: 'Enter the full URL beginning with http or https. (All fields are optional)'
    },
    BUSINESS_HOURS: {
      ADD_CALENDAR: 'Add to Calendar',
      USE_THIS_FORM: 'Use this form to assign holiday/special hours.',
      OVERRIDE_REGULAR_HOURS: `These will override your regular day's business hours.`,
      ANNUAL_DAY_ADD : 'Annual holiday added successfully',
      CUSTOM_DAY_ADD : 'Custom day added successfully',
      HOUR_DELETE: 'Annual holiday deleted successfully',
      CUSTOM_DAY_DELETE: 'Custom day deleted successfully',
      OVERLAY_VAILD_TIME_INFO: 'Examples of valid times to enter into fields are 3am, 4:30pm, 3:15pm and 3:45pm.',
      OVERLAY_15_MIN_INC: 'Must be in 15 minute increments or whole hour.',
      MENU_SCHEDULES: 'Use this button to show your menu schedules.',
      OVERRIDE_MENU_HOURS: 'Business hours always override menu schedules',
      OVERNIGHT_OPEN: 'Your restaurant will remain open overnight since next day is open for 24 hours.'
    },
    APT: {
      INFO: `Setting your average preparation times helps us determine the typical demand your restaurant's kitchen may have on specific days and times of the week.
             This helps us estimate delivery times before an order is placed, so customers can have an idea what to expect.`,
      INSTRUCTIONS_1: `When an order hits your kitchen, you'll also be giving customers a better estimate of the preparation time once accepted, and the customer is informed of that time.`,
      INSTRUCTIONS_2: `This feature will eventually become hidden (and adjusted dynamically) once our system has enough data about your restaurant's order history.`
    },
    LIST: {
      ACTIVATED: 'Restaurant activated successfully',
      DEACTIVATED: 'Restaurant deactivated successfully',
      CONFIRM_INACTIVE: 'Take Restaurant Offline (Inactive)',
    }
  }

  //#endregion

  //#region Refund Message

  public ORDER_REFUNDED = 'Amount refunded successfully';
  public ORDER_REFUND_REJECTED = 'Refund rejected successfully';

  public REFUND = 'Refund';
  public REJECT = 'Reject';
  public REFUND_REQUEST = 'Refund Request';
  public REFUND_REJECTED = 'Refund Rejected';
  public REFUND_REJECTED_REASON = 'Refund Rejected Reason';
  public REFUND_REJECTED_REASON_REQUIRED = 'Refund rejected reason is required';

  public YES_APPROVE = 'Yes, Approve';
  public YES_REJECT = 'Yes, Reject';

  //#endregion

  //#region Notification Message

  public ALL_ALREADY_SEEN = 'All notifications are already seen';
  
  public DELETED_ALL = 'All notifications are deleted successfully';
  public DELETED_SINGLE = 'Notification deleted successfully';
  public DELETE_ALL = 'Delete All';
  public DELETE_NOTIFICATION = 'Delete Notification';

  public HAVE_NOT_NOTIFICATION = `You haven't any notification`;

  public MARK_ALL = 'All notifications are mark as read';
  public MRAK_SINGLE = 'Notification mark as read successfully';
  public MARK_AS_READ = 'Mark As Read';

  public READ_ALL = 'Mark As Read All';

  //#endregion

  //#region Food Menu Editor

  public ADDED_ITEM_DELETED = 'Added item to menu deleted successfully';

  public CATEGORY_UPDATED = 'Menu updated successfully';
  public CATEGORY_ADDED = 'Menu added successfully';
  public CATEGORY_DELETED = 'Menu deleted successfully';

  public ITEM_DELETED = 'Item deleted successfully';
  public ITEM_UPDATED = 'Item updated successfully';
  public ITEM_ADDED = 'Item added successfully';
  public ITEM_UNDER_REVIEW = 'Item goes under review successfully';
  public IMAGE_UPLOADED = 'Image uploaded successfully';
  public ITEM_DETAILS_INFO = 'Item details are reflected on the website after you save details';
  public ITEM_STORE_DEACTIVATE = 'Item and Restaurant deactivated successfully';

  public SUB_CATEGORY_UPDATED = 'Category updated successfully';
  public SUB_CATEGORY_ADDED = 'Category added successfully';
  public SUB_CATEGORY_DELETED = 'Category deleted successfully';

  public TOPPINGS_DELETED = `Item's toppings deleted successfully`;
  public TOPPING_ADDED = 'Topping added successfully';
  public TOPPING_UPDATED = 'Topping updated successfully';

  public VARIANTS_DELETED = `Item's variants deleted successfully`;
  public VARIANTS_ADDED = 'Variant added successfully';
  public VARIANTS_NEW_ADDED = 'New variant added successfully';
  public VARIANTS_UPDATED = 'Variant updated successfully';

  //#endregion

  //#region Food Menu Editor Message

  public EXPORT_MENU_ITEM = 'Export Menu Item';

  public FOOD_MENU_EDITOR = 'Menu Manager';
  
  public TOPPING_INFO = 'You Can Click On Edit From The Right Side To Add More Toppings';
  public TOPPING_ATLEAST = 'Atleast 1 topping is required';

  public VARIANT_INFO = 'You Can Add Multiple Variants On Click Add Variant From Below';
  public VARIANT_ATLEAST = 'Atleast 1 option is required';

  public MENU_ACTIVE_TEXT = 'Active = Items on menu can be ordered';
  public MENU_INACTIVE_TEXT = 'Inactive = Items on menu are unavailable';

  public CATEGORY_ACTIVE_TEXT = 'Active = Items in category can be ordered';
  public CATEGORY_INACTIVE_TEXT = 'Inactive = Items in category are unavailable';

  public ACTIVE_TEXT = 'Active = Item is available on this menu';
  public INACTIVE_TEXT = 'Inactive = Item is not available on this menu';

  //#endregion

  //#region Menu Imports Message

  public MENU_IMPORT = 'Import/Export';
  public MENU_IMPORT_SUCCESS = 'Menu imported successfully';
  public MENU_IMPORT_SEARCH = 'Search By File Name and Status';

  public VIEW_ERRORS = 'View Errors';

  //#endregion

  //#region Media Gallery Message

  public COPY_URL = 'Copy URL';

  public IMAGE_REMOVED = 'Image removed successfully';
  public IMAGE_URL_COPIED = 'Image URL copied successfully';

  public MEDIA_GALLERY_UPDATED = 'Media gallery updated successfully';

  public SELECT_IMAGE_FIRST = 'Select image first';

  public UPLOAD_MEDIA = 'Upload Media';

  //#endregion

  //#region Discount Message

  public ADD_DISCOUNT_ADDED = 'Discount added successfully';
  
  public COMMON_SELECT_BOTH_DATE = 'Select Start and End Date';
  public COMMON_SELECT_END_DATE = 'Select End Date';
  public COMMON_SELECT_START_DATE = 'Select Start Date';
  public COMMON_AMOUNT_EXCEED = 'Discount Amount must be between 1 and 99%';
  
  public EDIT_DISCOUNT_UPDATED = 'Discount updated successfully';
  public EDIT_DISCOUNT_START_DATE_GREATER = 'Start Date is greater than current date and time';
  
  public DISCOUNT_REMOVED_SUCCESS = 'Discount removed successfully';
  public DISCOUNT_UNDER_REVIEW = 'Discount goes under review successfully';

  public LIST_DISCOUNT_ADD = 'Add Discount';
  public LIST_DISCOUNT_EDIT = 'Edit Discount';
  public LIST_DISCOUNT_DELETE = 'Delete Discount';
  public LIST_DISCOUNT_DELETED = 'Discount deleted successfully';
  public LIST_DISCOUNT_SEARCH = 'Type discount code...';
  public LIST_DISCOUNT_INFO = 'That is your restaurant discount';

  public SAME_DATE = 'Start date is greater than or equal to end date';

  public DISCOUNTS = {
    TYPE: 'Discount Type is required',
    AMOUNT_INVALID: 'Discount Amount is not valid',
    AMOUNT_VALUE_OVER: 'Discount amount must be a value over $1.00',
    MIN_CART_VALUE_OVER: 'Minimum Cart must be a value over $1.00',
    AMOUNT_EXCEED: 'Discount amount cannot exceed minimum cart total',
    MIN_CART_GREATER: 'Minimum Cart Total must be higher than discount amount',
    PROMOTIONAL_HOURS: 'End date/time must be at least 1 hour after the start date/time',
    CHANGE_FUTURE_END_DATE: 'Please change the End Date to being a date in the future',
    LIST_CHANGE_FUTURE_END_DATE: 'To let this discount Run again, please change the End Date to being a date in the future.',
    DELETED_SUCCESS: 'Discount deleted Successfully',
    CREATE_DISCOUNT: 'Create Discount',
    YES_DELETE_IT: 'Yes, delete it',
    DATE_INVALID: 'is not valid date',
    MINIMUM_CART_TOTAL_INVALID: 'Minimum Cart Total is not valid',
    MAX_USES_PER_CUSTOMER_INVALID: 'Maximum Uses Per Customer is not valid',
    MAX_USES_OVERALL_INVALID: 'Maximum Uses Overall is not valid'
  }

  //#endregion

  //#region Razor Delivery Messages

  public COPY_PASSWORD = 'Copy Password';

  public DE_ACTIVATE = 'De-Activate';

  public NG_DEL_SETUP = 'Successfully setup with Razor Delivery';
  public NG_DEL_RE_ACTIVATE = 'Successfully re-activated with Razor Delivery';
  public NG_DEL_DE_ACTIVATE = 'Successfully de-activated with Razor Delivery';
  public NG_DEL = 'Razor Delivery';

  public RE_ACTIVATE = 'Re-Activate';

  public SET_UP = 'Set Up';
  public UN_SUBSCRIBE = 'Un-Subscribe';

  //#endregion

  //#region restaurant settings

  public AGREE = 'I, Agree';

  public EDIT_TAX_PERCENT = 'Edit Sales Tax Rate';

  public SETTING_UPDATED = 'Basic settings updated successfully';
  public SUB_DOMAIN_UPDATED = 'Sub Domain updated successfully';

  //#endregion

  //#region NG Rider messages

  public ADD_PAYMENT_ADDED = 'Payment Method added successfully';

  public COUPON_APPLIED = 'Coupon applied successfully';
  public COUPON_REMOVED = 'Coupon removed successfully';

  public EDIT_PAYMENT_UPDATED = 'Payment Method updated successfully';
  
  public LIST_PAYMENT_DELETED = 'Payment Method deleted successfully';
  public LIST_PAYMENT_ADD = 'Add Payment Method';
  public LIST_PAYMENT_EDIT = 'Edit Payment Method';
  public LIST_PAYMENT_DELETE = 'Delete Payment Method';
  public LIST_PAYMENT_SEARCH = 'Search By Name, Email Address and Phone';
  public LIST_VERIFY_BANK_ACCOUNT = 'Verify Bank Account';
  public LIST_VERIFY_BANK_ACCOUNT_VERIFIED = 'Bank Account verified successfully';
  public LIST_DELIVERY_PARTNER = 'The Restaurant is not delivery parther with CMO Rider';
  
  public SUBS_UPDATE = 'It takes few time to update'
  public SUBS_SUCCESS = 'Subscription created successfully';
  public SUBS_RE_ACTIVATE = 'Subscription re-activated successfully';
  public SUBS_DE_ACTIVATE = 'Subscription de-activated successfully';
  public SUBS_UN_SUBSCRIBE = 'Subscription un-subscribed successfully';
  public SELECT_PLAN = 'Please select the plan from above';
  
  public UPDATE_PLAN = 'Change Subscription Plan';

  //#endregion

  //#region contact us

  public CREATE_TICKET = 'New Ticket';

  public TICKET_CREATED = 'New Ticket created successfully';

  public MENTION_FIELD =  'Above mention fields are required';

  //#endregion

  //#region payouts

  public PAYOUT_ADD_UPDATE = 'Update Payout Method';

  //#endregion

  //#region kiosks
  public KIOSK_ADD = 'Add Kiosk';
  public KIOSK_UPDATE = 'Update Kiosk';
  public KIOSK_REMOVE = 'Remove Kiosk';
  public KIOSK_EDIT = 'Edit Kiosk';
  public KIOSK_VERIFY = 'Verify Kiosk';
  public KIOSK_DETAILS = 'Kiosk Details';
  public KIOSK_SEARCH_BY_NAME = 'Search by Kiosk Name';
  public DELETE_KIOSK = 'Delete Kiosk Device';
  public DELETE_KIOSK_LOGO = 'Delete Kiosk Logo';
  public DELETE_KIOSK_SCREEN_SAVER = 'Delete Kiosk Screensaver'
  public KIOSK_ORDER_DETAILS = 'View Order';
  
  public KIOSK_CONTROLS = {
    'NAME' : 'Kiosk Name',
    'CODE' : 'Verification Code'
  }

  public KIOSK_ACTIVE_STATUS = [
    {
      label: 'Active',
      value: true
    },
    {
      label: 'Inactive',
      value: false
    }
  ];
  //#endregion

  //#region Other Constant

  public BUSINESS_HOURS_OBJ = {
    business_hours: [{
      day: 'Monday',
      open: null,
      close: null,
      late: null,
      option: null,
    },
    {
      day: 'Tuesday',
      open: null,
      close: null,
      late: null,
      option: null,
    },
    {
      day: 'Wednesday',
      open: null,
      close: null,
      late: null,
      option: null,
    },
    {
      day: 'Thursday',
      open: null,
      close: null,
      late: null,
      option: null,
    },
    {
      day: 'Friday',
      open: null,
      close: null,
      late: null,
      option: null,
    },
    {
      day: 'Saturday',
      open: null,
      close: null,
      late: null,
      option: null,
    },
    {
      day: 'Sunday',
      open: null,
      close: null,
      late: null,
      option: null,
    }]
  };

  public GALLERY_OPTIONS = [
    {
      width: '100%',
      height: '250px',
      thumbnailsColumns: 1,
      arrowPrevIcon: 'fa fa-chevron-left',
      arrowNextIcon: 'fa fa-chevron-right',
      zoomInIcon: 'fa fa-search-plus',
      imageAnimation: NgxGalleryAnimation.Slide,
      previewZoom: true,
      previewZoomStep: 0.4,
      previewZoomMax: 2,
      previewZoomMin: 1,
      image: false,
      thumbnailsArrows: true,
      previewArrows: false,
      previewCloseOnClick: true,
      thumbnailSize: NgxGalleryImageSize.Cover,
      lazyLoading: true,
    },
    {
      breakpoint: 800,
      imagePercent: 20,
      thumbnailsPercent: 20,
      thumbnailsMargin: 20,
      thumbnailMargin: 20,
    },
    {
      breakpoint: 400,
      preview: true,
    }
  ];

  public ORDER_TYPE_LIST = [
    {
      label: 'Pickup',
      value: 'Pickup'
    },
    {
      label: 'Delivery',
      value: 'Delivery'
    },
    {
      label: 'Dine-in',
      value: 'Dinein'
    },
    {
      label: 'Table',
      value: 'Table'
    }
  ];

  public ORDER_MODE_LIST = [
    {
      label: 'Cart Order',
      value: 'cart_order'
    },
    {
      label: 'Chat Order',
      value: 'chat_order'
    },
    {
      label: 'POS Order',
      value: 'pos_order'
    },
    {
      label: 'Table Order',
      value: 'table_order'
    }
  ];

  public CUTOFF_TIME_SLOTS = [
    15, 30, 45, 60,
  ];

  public RADIUS_MILES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  public ACH_TYPES = [
    {
      value: 'individual',
      label: 'Individual'
    },
    {
      value: 'company',
      label: 'Company'
    },
  ];

  public MONTH_LIST = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  public ITEM_PLACEHOLDER_IMAGE = 'assets/images/item_placeholder.png';
  public RESTAURANT_PLACEHOLDER_IMAGE = 'assets/images/restaurant_placeholder.png';

  public REPORT_FILTER_OPTIONS = ['Daily', 'Weekly', 'Biweekly', 'Monthly', 'Yearly'];

  public STORE_KEY_NAME = [
    {
      label: 'Name',
      value: 'name',
    },
    {
      label: 'Phone',
      value: 'phone',
    },
    {
      label: 'Email Address',
      value: 'email',
    },
    {
      label: 'Address',
      value: 'address',
    },
    {
      label: 'Description',
      value: 'description',
    },
    {
      label: 'Category',
      value: 'categories',
    },
    {
      label: 'Tags',
      value: 'tags',
    },
    {
      label: 'Fulfillment Types',
      value: 'fulfillment_types',
    },
    {
      label: 'Active',
      value: 'is_active',
    },
    {
      label: 'Employer ID Number(EIN)',
      value: 'tax_id',
    },
    {
      label: 'Doing Business As',
      value: 'doing_business_as',
    },
    {
      label: 'EIN Document',
      value: 'tax_id_document',
    },
    {
      label: 'Doing Business As Document',
      value: 'doing_business_as_document',
    },
    {
      label: 'Cost For Two',
      value: 'cost_for_two',
    },
    {
      label: 'Formatted Cost For Two',
      value: 'formatted_cost_for_two'
    },
    {
      label: 'Avg. Food Preparation Time (in minutes)',
      value: 'avg_prepare_time',
    },
    {
      label: 'Social Links',
      value: 'social_links'
    }
  ];

  public DISCOUNT_KEY_NAME = [
    {
      label: 'Title',
      value: 'title',
    },
    {
      label: 'Description',
      value: 'description',
    },
    {
      label: 'Condition',
      value: 'condition',
    },
    {
      label: 'Amount',
      value: 'amount',
    },
    {
      label: 'Type',
      value: 'type',
    },
    {
      label: 'Start Date',
      value: 'start_date',
    },
    {
      label: 'End Date',
      value: 'end_date',
    },
    {
      label: 'Maximum Discount',
      value: 'maximum_discount',
    },
    {
      label: 'Minimum Cart Total',
      value: 'minimum_cart_total',
    },
    {
      label: 'Single User Count',
      value: 'use_count_single_user',
    },
    {
      label: 'All User Count',
      value: 'use_count_all_user',
    },
    {
      label: 'Current Use Count',
      value: 'current_use_count',
    },
    {
      label: 'Active',
      value: 'is_active',
    },
    {
      label: 'Category',
      value: 'categories',
    },
    {
      label: 'Updated At',
      value: 'updated'
    },
  ]

  public TICKET_SUBJECT_LIST = [
    'Serious Allergic Reaction',
    'Serious Food Safety Issue',
    'Violence and/or other Criminal Activity',
    'Other',
  ];

  public PRICE_LEVEL = [
    {
      label: '$ - Entree items mostly under $10',
      value: 1,
    },
    {
      label: '$$ - Entree items mostly between $10-$20',
      value: 2,
    },
    {
      label: '$$$ - Entree items mostly between $20-$30',
      value: 3,
    },
    {
      label: '$$$$ - Entree items mostly above $30',
      value: 4,
    },
  ]

  public SLOT_TIME = [
    {
      label: '5',
      value: 5
    },
    {
      label: '10',
      value: 10
    },
    {
      label: '15',
      value: 15
    },
    {
      label: '20',
      value: 20
    },
    {
      label: '25',
      value: 25
    },
    {
      label: '30',
      value: 30
    },
    {
      label: '35',
      value: 35
    },
    {
      label: '40',
      value: 40
    },
    {
      label: '45',
      value: 45
    },
    {
      label: '50',
      value: 50
    },
    {
      label: '55',
      value: 55
    },
    {
      label: '60',
      value: 60
    }
  ];

  public APT_OBJ_ARRAY = {
    apt_hours: [{
      day: 'Monday',
      options: [{
        slot: '12:00 AM',
        slot_number: 0,
        min: 15,
      },
      {
        slot: '01:00 AM',
        slot_number: 1,
        min: 15,
      },
      {
        slot: '02:00 AM',
        slot_number: 2,
        min: 15,
      },
      {
        slot: '03:00 AM',
        slot_number: 3,
        min: 15,
      },
      {
        slot: '04:00 AM',
        slot_number: 4,
        min: 15,
      },
      {
        slot: '05:00 AM',
        slot_number: 5,
        min: 15,
      },
      {
        slot: '06:00 AM',
        slot_number: 6,
        min: 15,
      },
      {
        slot: '07:00 AM',
        slot_number: 7,
        min: 15,
      },
      {
        slot: '08:00 AM',
        slot_number: 8,
        min: 15,
      },
      {
        slot: '09:00 AM',
        slot_number: 9,
        min: 15,
      },
      {
        slot: '10:00 AM',
        slot_number: 10,
        min: 15,
      },
      {
        slot: '11:00 AM',
        slot_number: 11,
        min: 15,
      },
      {
        slot: '12:00 PM',
        slot_number: 12,
        min: 15,
      },
      {
        slot: '01:00 PM',
        slot_number: 13,
        min: 15,
      },
      {
        slot: '02:00 PM',
        slot_number: 14,
        min: 15,
      },
      {
        slot: '03:00 PM',
        slot_number: 15,
        min: 15,
      },
      {
        slot: '04:00 PM',
        slot_number: 16,
        min: 15,
      },
      {
        slot: '05:00 PM',
        slot_number: 17,
        min: 15,
      },
      {
        slot: '06:00 PM',
        slot_number: 18,
        min: 15,
      },
      {
        slot: '07:00 PM',
        slot_number: 19,
        min: 15,
      },
      {
        slot: '08:00 PM',
        slot_number: 20,
        min: 15,
      },
      {
        slot: '09:00 PM',
        slot_number: 21,
        min: 15,
      },
      {
        slot: '10:00 PM',
        slot_number: 22,
        min: 15,
      },
      {
        slot: '11:00 PM',
        slot_number: 23,
        min: 15,
      }],
    },
    {
      day: 'Tuesday',
      options: [{
        slot: '12:00 AM',
        slot_number: 0,
        min: 15,
      },
      {
        slot: '01:00 AM',
        slot_number: 1,
        min: 15,
      },
      {
        slot: '02:00 AM',
        slot_number: 2,
        min: 15,
      },
      {
        slot: '03:00 AM',
        slot_number: 3,
        min: 15,
      },
      {
        slot: '04:00 AM',
        slot_number: 4,
        min: 15,
      },
      {
        slot: '05:00 AM',
        slot_number: 5,
        min: 15,
      },
      {
        slot: '06:00 AM',
        slot_number: 6,
        min: 15,
      },
      {
        slot: '07:00 AM',
        slot_number: 7,
        min: 15,
      },
      {
        slot: '08:00 AM',
        slot_number: 8,
        min: 15,
      },
      {
        slot: '09:00 AM',
        slot_number: 9,
        min: 15,
      },
      {
        slot: '10:00 AM',
        slot_number: 10,
        min: 15,
      },
      {
        slot: '11:00 AM',
        slot_number: 11,
        min: 15,
      },
      {
        slot: '12:00 PM',
        slot_number: 12,
        min: 15,
      },
      {
        slot: '01:00 PM',
        slot_number: 13,
        min: 15,
      },
      {
        slot: '02:00 PM',
        slot_number: 14,
        min: 15,
      },
      {
        slot: '03:00 PM',
        slot_number: 15,
        min: 15,
      },
      {
        slot: '04:00 PM',
        slot_number: 16,
        min: 15,
      },
      {
        slot: '05:00 PM',
        slot_number: 17,
        min: 15,
      },
      {
        slot: '06:00 PM',
        slot_number: 18,
        min: 15,
      },
      {
        slot: '07:00 PM',
        slot_number: 19,
        min: 15,
      },
      {
        slot: '08:00 PM',
        slot_number: 20,
        min: 15,
      },
      {
        slot: '09:00 PM',
        slot_number: 21,
        min: 15,
      },
      {
        slot: '10:00 PM',
        slot_number: 22,
        min: 15,
      },
      {
        slot: '11:00 PM',
        slot_number: 23,
        min: 15,
      }],
    },
    {
      day: 'Wednesday',
      options: [{
        slot: '12:00 AM',
        slot_number: 0,
        min: 15,
      },
      {
        slot: '01:00 AM',
        slot_number: 1,
        min: 15,
      },
      {
        slot: '02:00 AM',
        slot_number: 2,
        min: 15,
      },
      {
        slot: '03:00 AM',
        slot_number: 3,
        min: 15,
      },
      {
        slot: '04:00 AM',
        slot_number: 4,
        min: 15,
      },
      {
        slot: '05:00 AM',
        slot_number: 5,
        min: 15,
      },
      {
        slot: '06:00 AM',
        slot_number: 6,
        min: 15,
      },
      {
        slot: '07:00 AM',
        slot_number: 7,
        min: 15,
      },
      {
        slot: '08:00 AM',
        slot_number: 8,
        min: 15,
      },
      {
        slot: '09:00 AM',
        slot_number: 9,
        min: 15,
      },
      {
        slot: '10:00 AM',
        slot_number: 10,
        min: 15,
      },
      {
        slot: '11:00 AM',
        slot_number: 11,
        min: 15,
      },
      {
        slot: '12:00 PM',
        slot_number: 12,
        min: 15,
      },
      {
        slot: '01:00 PM',
        slot_number: 13,
        min: 15,
      },
      {
        slot: '02:00 PM',
        slot_number: 14,
        min: 15,
      },
      {
        slot: '03:00 PM',
        slot_number: 15,
        min: 15,
      },
      {
        slot: '04:00 PM',
        slot_number: 16,
        min: 15,
      },
      {
        slot: '05:00 PM',
        slot_number: 17,
        min: 15,
      },
      {
        slot: '06:00 PM',
        slot_number: 18,
        min: 15,
      },
      {
        slot: '07:00 PM',
        slot_number: 19,
        min: 15,
      },
      {
        slot: '08:00 PM',
        slot_number: 20,
        min: 15,
      },
      {
        slot: '09:00 PM',
        slot_number: 21,
        min: 15,
      },
      {
        slot: '10:00 PM',
        slot_number: 22,
        min: 15,
      },
      {
        slot: '11:00 PM',
        slot_number: 23,
        min: 15,
      }],
    },
    {
      day: 'Thursday',
      options: [{
        slot: '12:00 AM',
        slot_number: 0,
        min: 15,
      },
      {
        slot: '01:00 AM',
        slot_number: 1,
        min: 15,
      },
      {
        slot: '02:00 AM',
        slot_number: 2,
        min: 15,
      },
      {
        slot: '03:00 AM',
        slot_number: 3,
        min: 15,
      },
      {
        slot: '04:00 AM',
        slot_number: 4,
        min: 15,
      },
      {
        slot: '05:00 AM',
        slot_number: 5,
        min: 15,
      },
      {
        slot: '06:00 AM',
        slot_number: 6,
        min: 15,
      },
      {
        slot: '07:00 AM',
        slot_number: 7,
        min: 15,
      },
      {
        slot: '08:00 AM',
        slot_number: 8,
        min: 15,
      },
      {
        slot: '09:00 AM',
        slot_number: 9,
        min: 15,
      },
      {
        slot: '10:00 AM',
        slot_number: 10,
        min: 15,
      },
      {
        slot: '11:00 AM',
        slot_number: 11,
        min: 15,
      },
      {
        slot: '12:00 PM',
        slot_number: 12,
        min: 15,
      },
      {
        slot: '01:00 PM',
        slot_number: 13,
        min: 15,
      },
      {
        slot: '02:00 PM',
        slot_number: 14,
        min: 15,
      },
      {
        slot: '03:00 PM',
        slot_number: 15,
        min: 15,
      },
      {
        slot: '04:00 PM',
        slot_number: 16,
        min: 15,
      },
      {
        slot: '05:00 PM',
        slot_number: 17,
        min: 15,
      },
      {
        slot: '06:00 PM',
        slot_number: 18,
        min: 15,
      },
      {
        slot: '07:00 PM',
        slot_number: 19,
        min: 15,
      },
      {
        slot: '08:00 PM',
        slot_number: 20,
        min: 15,
      },
      {
        slot: '09:00 PM',
        slot_number: 21,
        min: 15,
      },
      {
        slot: '10:00 PM',
        slot_number: 22,
        min: 15,
      },
      {
        slot: '11:00 PM',
        slot_number: 23,
        min: 15,
      }],
    },
    {
      day: 'Friday',
      options: [{
        slot: '12:00 AM',
        slot_number: 0,
        min: 15,
      },
      {
        slot: '01:00 AM',
        slot_number: 1,
        min: 15,
      },
      {
        slot: '02:00 AM',
        slot_number: 2,
        min: 15,
      },
      {
        slot: '03:00 AM',
        slot_number: 3,
        min: 15,
      },
      {
        slot: '04:00 AM',
        slot_number: 4,
        min: 15,
      },
      {
        slot: '05:00 AM',
        slot_number: 5,
        min: 15,
      },
      {
        slot: '06:00 AM',
        slot_number: 6,
        min: 15,
      },
      {
        slot: '07:00 AM',
        slot_number: 7,
        min: 15,
      },
      {
        slot: '08:00 AM',
        slot_number: 8,
        min: 15,
      },
      {
        slot: '09:00 AM',
        slot_number: 9,
        min: 15,
      },
      {
        slot: '10:00 AM',
        slot_number: 10,
        min: 15,
      },
      {
        slot: '11:00 AM',
        slot_number: 11,
        min: 15,
      },
      {
        slot: '12:00 PM',
        slot_number: 12,
        min: 15,
      },
      {
        slot: '01:00 PM',
        slot_number: 13,
        min: 15,
      },
      {
        slot: '02:00 PM',
        slot_number: 14,
        min: 15,
      },
      {
        slot: '03:00 PM',
        slot_number: 15,
        min: 15,
      },
      {
        slot: '04:00 PM',
        slot_number: 16,
        min: 15,
      },
      {
        slot: '05:00 PM',
        slot_number: 17,
        min: 15,
      },
      {
        slot: '06:00 PM',
        slot_number: 18,
        min: 15,
      },
      {
        slot: '07:00 PM',
        slot_number: 19,
        min: 15,
      },
      {
        slot: '08:00 PM',
        slot_number: 20,
        min: 15,
      },
      {
        slot: '09:00 PM',
        slot_number: 21,
        min: 15,
      },
      {
        slot: '10:00 PM',
        slot_number: 22,
        min: 15,
      },
      {
        slot: '11:00 PM',
        slot_number: 23,
        min: 15,
      }],
    },
    {
      day: 'Saturday',
      options: [{
        slot: '12:00 AM',
        slot_number: 0,
        min: 15,
      },
      {
        slot: '01:00 AM',
        slot_number: 1,
        min: 15,
      },
      {
        slot: '02:00 AM',
        slot_number: 2,
        min: 15,
      },
      {
        slot: '03:00 AM',
        slot_number: 3,
        min: 15,
      },
      {
        slot: '04:00 AM',
        slot_number: 4,
        min: 15,
      },
      {
        slot: '05:00 AM',
        slot_number: 5,
        min: 15,
      },
      {
        slot: '06:00 AM',
        slot_number: 6,
        min: 15,
      },
      {
        slot: '07:00 AM',
        slot_number: 7,
        min: 15,
      },
      {
        slot: '08:00 AM',
        slot_number: 8,
        min: 15,
      },
      {
        slot: '09:00 AM',
        slot_number: 9,
        min: 15,
      },
      {
        slot: '10:00 AM',
        slot_number: 10,
        min: 15,
      },
      {
        slot: '11:00 AM',
        slot_number: 11,
        min: 15,
      },
      {
        slot: '12:00 PM',
        slot_number: 12,
        min: 15,
      },
      {
        slot: '01:00 PM',
        slot_number: 13,
        min: 15,
      },
      {
        slot: '02:00 PM',
        slot_number: 14,
        min: 15,
      },
      {
        slot: '03:00 PM',
        slot_number: 15,
        min: 15,
      },
      {
        slot: '04:00 PM',
        slot_number: 16,
        min: 15,
      },
      {
        slot: '05:00 PM',
        slot_number: 17,
        min: 15,
      },
      {
        slot: '06:00 PM',
        slot_number: 18,
        min: 15,
      },
      {
        slot: '07:00 PM',
        slot_number: 19,
        min: 15,
      },
      {
        slot: '08:00 PM',
        slot_number: 20,
        min: 15,
      },
      {
        slot: '09:00 PM',
        slot_number: 21,
        min: 15,
      },
      {
        slot: '10:00 PM',
        slot_number: 22,
        min: 15,
      },
      {
        slot: '11:00 PM',
        slot_number: 23,
        min: 15,
      }],
    },
    {
      day: 'Sunday',
      options: [{
        slot: '12:00 AM',
        slot_number: 0,
        min: 15,
      },
      {
        slot: '01:00 AM',
        slot_number: 1,
        min: 15,
      },
      {
        slot: '02:00 AM',
        slot_number: 2,
        min: 15,
      },
      {
        slot: '03:00 AM',
        slot_number: 3,
        min: 15,
      },
      {
        slot: '04:00 AM',
        slot_number: 4,
        min: 15,
      },
      {
        slot: '05:00 AM',
        slot_number: 5,
        min: 15,
      },
      {
        slot: '06:00 AM',
        slot_number: 6,
        min: 15,
      },
      {
        slot: '07:00 AM',
        slot_number: 7,
        min: 15,
      },
      {
        slot: '08:00 AM',
        slot_number: 8,
        min: 15,
      },
      {
        slot: '09:00 AM',
        slot_number: 9,
        min: 15,
      },
      {
        slot: '10:00 AM',
        slot_number: 10,
        min: 15,
      },
      {
        slot: '11:00 AM',
        slot_number: 11,
        min: 15,
      },
      {
        slot: '12:00 PM',
        slot_number: 12,
        min: 15,
      },
      {
        slot: '01:00 PM',
        slot_number: 13,
        min: 15,
      },
      {
        slot: '02:00 PM',
        slot_number: 14,
        min: 15,
      },
      {
        slot: '03:00 PM',
        slot_number: 15,
        min: 15,
      },
      {
        slot: '04:00 PM',
        slot_number: 16,
        min: 15,
      },
      {
        slot: '05:00 PM',
        slot_number: 17,
        min: 15,
      },
      {
        slot: '06:00 PM',
        slot_number: 18,
        min: 15,
      },
      {
        slot: '07:00 PM',
        slot_number: 19,
        min: 15,
      },
      {
        slot: '08:00 PM',
        slot_number: 20,
        min: 15,
      },
      {
        slot: '09:00 PM',
        slot_number: 21,
        min: 15,
      },
      {
        slot: '10:00 PM',
        slot_number: 22,
        min: 15,
      },
      {
        slot: '11:00 PM',
        slot_number: 23,
        min: 15,
      }],
    }
  ]}

  public WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  public MENU_WEEK_DAYS = [
    {
      lable: 'MON',
      value: 'Monday',
    },
    {
      lable: 'TUE',
      value: 'Tuesday'
    },
    {
      lable: 'WED',
      value: 'Wednesday'
    },
    {
      lable: 'THU',
      value: 'Thursday'
    },
    {
      lable: 'FRI',
      value: 'Friday'
    },
    {
      lable: 'SAT',
      value: 'Saturday'
    },
    {
      lable: 'SUN',
      value: 'Sunday'
    }
  ];


  public PAUSE_DELIVERY_SLOT = [
    {
      label: 'Pause/Unpause Manually',
      value: 0,
    },
    {
      label: '10 Minutes',
      value: 10,
    },
    {
      label: '20 Minutes',
      value: 20,
    },
    {
      label: '30 Minutes',
      value: 30,
    },
    {
      label: '1 Hour',
      value: 60,
    },
    {
      label: 'Rest of the Day',
      value: 1440,
    },
  ];

  public DISCOUNT_STATUS_LIST = ['Running', 'Upcoming', 'Ended'];

  public BUSINESS_ENTITY_TYPE = [
    'Limited Liability Company', 'Partnership', 'C Corporation', 'S Corporation', 'Sole Proprietorship'
  ];

  public ONBOARDING_KEYS = [
    {
      key: 'restaurant_logo',
      url: '',
      store_id: true,
    },
    {
      key: 'restaurant_menu',
      url: '/pages/menus/menu-editor-v2',
      store_id: false,
    },
    {
      key: 'tax_and_settings',
      url: '/pages/stores/basic-settings',
      store_id: false,
    },
    {
      key: 'business_hours',
      url: '/pages/stores/store-business-hours',
      store_id: false,
    },
    {
      key: 'auth_pin',
      url: '/pages/profile',
      store_id: false,
    },
    {
      key: 'payouts',
      url: '/pages/payouts/payout-settings',
      store_id: false,
    },
    {
      key: 'delivery_setup',
      url: '/pages/general-config/delivery-setup/plan-setup',
      store_id: false,
    },
    {
      key: 'pos_terminal',
      url: '/pages/general-config/stripe-terminal',
      store_id: false,
    },
    {
      key: 'apt_hours',
      url: '/pages/stores/store-apt-hours',
      store_id: false,
    },
    {
      key: 'restaurant_staff',
      url: '/pages/staffs/list',
      store_id: false,
    },
    {
      key: 'restaurant_gallery',
      url: '/pages/stores/restaurant-gallery',
      store_id: false,
    },
    {
      key: 'menu_gallery',
      url: '/pages/menus/menu-gallery',
      store_id: false,
    },
    {
      key: 'restaurant_discounts',
      url: '/pages/discount/list',
      store_id: false,
    }
  ];

  public USER_ROLES = [
    {
      label: 'Manager',
      value: 'storemanager'
    },
    {
      label: 'Staff',
      value: 'storestaff',
    }
  ];

  public DEVICE = 'web';
  public ROLE_TYPE = 'business';
  public REFRESH_TOKEN_INTERVAL = 2700 * 1000; // 45 min
  public CHAT_COUNT_INTERVAL = 2 * 60 * 1000; // 2 min
  public REMOVE_SCROLL_HEIGHT_VALUE = 100;
  public SUBSCRIPTION_STATUS = ['active', 'incomplete', 'trialing'];
  // public IN_PREP_ORDER_STATUSES = ['Received', 'Accepted', 'On The Way', 'Ready For Pickup', 'Being Prepared', 'Action Required'];
  public IN_PREP_ORDER_STATUSES = ['Being Prepared'];
  public BUSINESS_HOUR_OPTIONS = [
   
    {
      value: 'all',
      label: 'All Day (24 Hours)'
    },
    {
      value: 'closed',
      label: 'Closed'
    },
  ];
  public SPECIAL_HOUR_OPTIONS = [
    {
      value: 'late',
      label: 'Open Late (Past midnight)'
    },
   
    {
      value: 'all',
      label: 'All Day (24 Hours)'
    },
    {
      value: 'closed',
      label: 'Closed'
    },
  ];

  public PLACE_HOLDER_IMAGE = 'https://chatmyorder.blob.core.windows.net/cmo/store/logo/place-placeholder.jpg';

  //#endregion

  constructor() { }

}
